import { render, staticRenderFns } from "./TransactionNotification.vue?vue&type=template&id=1d3e0b50&scoped=true&lang=html&"
import script from "./TransactionNotification.vue?vue&type=script&lang=js&"
export * from "./TransactionNotification.vue?vue&type=script&lang=js&"
import style0 from "./TransactionNotification.vue?vue&type=style&index=0&id=1d3e0b50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3e0b50",
  null
  
)

export default component.exports